import { render, staticRenderFns } from "./ModalReleaseDetails.vue?vue&type=template&id=3c721f5c&scoped=true"
import script from "./ModalReleaseDetails.vue?vue&type=script&lang=js"
export * from "./ModalReleaseDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalReleaseDetails.vue?vue&type=style&index=0&id=3c721f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c721f5c",
  null
  
)

export default component.exports